import * as Yup from 'yup';
import { shipmentFormValidationSchema } from './validationSchemas';

const IrelandCountryCode = 'IE';

export enum Steps {
    SHIPMENT = 'shipment',
    FORM = 'form',
    CUSTOMER = 'customer',
    TEMPLATE = 'template',
    SHIPMENT_DETAILS = 'shipmentDetails',
    BULK_SUBMISSION = 'bulkSubmission',
}

export const initialValues: NewShipmentFormFields = {
    [Steps.SHIPMENT]: {
        shipmentId: '',
    },
    [Steps.FORM]: {
        formType: '(H7) Low-Value Consignments',
    },
    [Steps.CUSTOMER]: {
        customerId: '',
    },
    [Steps.TEMPLATE]: {
        templateId: '',
    },
    [Steps.SHIPMENT_DETAILS]: {
        carrier: '',
        countryOriginCode: '',
        entryCountryCode: IrelandCountryCode,
        destinationCode: '',
        eta: '',
    },
    [Steps.BULK_SUBMISSION]: {
        s3Link: '',
    },
};

export type NewShipmentFormFields = Yup.InferType<typeof shipmentFormValidationSchema>;
